// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__58Nvl","item":"PaymentsMobile_item__1Kn7K","label":"PaymentsMobile_label__33WNb","amount":"PaymentsMobile_amount__1ufXP"};